import { numberFormat } from "utils";
import { salaryDriverColNm } from "./constant";
import { IconButton } from "@mui/material";
import { ArticleRounded } from "resource/muiImport";
import dayjs from "dayjs";

export const columns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "DrvCd",
    headerName: "รหัสพนักงาน",
    width: 90,
  },
  {
    field: "DrvNm",
    headerName: "ชื่อ-นามสกุล",
    width: 180,
  },
  {
    field: "SalAmnt",
    headerName: salaryDriverColNm.SalAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "IncAmnt2",
    headerName: salaryDriverColNm.IncAmnt2,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "IncAmnt1",
    headerName: salaryDriverColNm.IncAmnt1,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "IncAmnt3",
    headerName: salaryDriverColNm.IncAmnt3,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "IncAmnt4",
    headerName: salaryDriverColNm.IncAmnt4,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "IncAmnt5",
    headerName: salaryDriverColNm.IncAmnt5,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "OthAmnt",
    headerName: salaryDriverColNm.OthAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "OthDscp",
    headerName: salaryDriverColNm.OthDscp,
    width: 100,
  },
  {
    field: "TripAmnt",
    headerName: salaryDriverColNm.TripAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "AdvAmnt",
    headerName: salaryDriverColNm.AdvAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "TrnsAmnt",
    headerName: salaryDriverColNm.TrnsAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  // {
  //   field: "CalLeftAmnt",
  //   headerName: "คำณวน",
  //   width: 100,
  //   type: "number",
  //   align: "right",
  //   valueGetter: ({row:{TripAmnt, AdvAmnt, TrnsAmnt}}) => +(TripAmnt || 0) + +(AdvAmnt || 0) - +(TrnsAmnt || 0) , 
  //   valueFormatter: (params) => {
  //     return params.value ? numberFormat(params.value) : "-";
  //   },
  // },
  {
    field: "LeftAmnt",
    headerName: salaryDriverColNm.LeftAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: ({ value }) => {
      
      return value ? numberFormat(value) : "0.00";
    },
    cellClassName: ({ value, row: { TripAmnt, AdvAmnt, TrnsAmnt } }) =>
      (+(TripAmnt || 0) + +(AdvAmnt || 0) - +(TrnsAmnt || 0)).toFixed(2) === (+value).toFixed(2) ? "" : "col-red"
  },
  {
    field: "TotalInc",
    headerName: salaryDriverColNm.TotalInc,
    width: 100,
    type: "number",
    align: "right",
    valueGetter: ({ row: { SalAmnt, IncAmnt2, IncAmnt1, IncAmnt3, IncAmnt4, OthAmnt, LeftAmnt, IncAmnt5 } }) =>
      +(SalAmnt || 0) + +(IncAmnt2 || 0) + +(IncAmnt1 || 0) + +(IncAmnt3 || 0) + +(IncAmnt4 || 0) + +(OthAmnt || 0) 
      + +(LeftAmnt || 0)+ +(IncAmnt5 || 0),
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeSSPrct",
    headerName: salaryDriverColNm.DeSSPrct,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? params.value : "-";
    },
  },
  {
    field: "DeSSAmnt",
    headerName: salaryDriverColNm.DeSSAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueGetter: ({ value }) => Math.round(value),
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeTaxAmnt",
    headerName: salaryDriverColNm.DeTaxAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeAmnt1",
    headerName: salaryDriverColNm.DeAmnt1,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeAmnt2",
    headerName: salaryDriverColNm.DeAmnt2,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeSecDepAmnt",
    headerName: salaryDriverColNm.DeSecDepAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeEduLoanAmnt",
    headerName: salaryDriverColNm.DeEduLoanAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeTfcFineAmnt",
    headerName: salaryDriverColNm.DeTfcFineAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeOthAmnt",
    headerName: salaryDriverColNm.DeOthAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeOthDscp",
    headerName: salaryDriverColNm.DeOthDscp,
    width: 150,
  },
  {
    field: "TotalDeduc",
    headerName: salaryDriverColNm.TotalDedc,
    width: 100,
    type: "number",
    align: "right",
    valueGetter: ({ row: { DeAmnt1, DeAmnt2, DeSecDepAmnt, DeSSAmnt, DeOthAmnt, DeEduLoanAmnt
      , DeTfcFineAmnt, DeTaxAmnt } }) =>
      +(DeAmnt1 || 0) + +(DeAmnt2 || 0) + +(DeSecDepAmnt || 0) + +(DeSSAmnt || 0)
      + +(DeOthAmnt || 0) + +(DeTfcFineAmnt || 0) + +(DeEduLoanAmnt || 0) + +(DeTaxAmnt || 0),
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "GrndTotal",
    headerName: salaryDriverColNm.GrndTotal,
    width: 100,
    type: "number",
    align: "right",
    valueGetter: ({ row: { SalAmnt, IncAmnt2, IncAmnt1, IncAmnt3, IncAmnt4, IncAmnt5, OthAmnt, LeftAmnt,
      DeAmnt1, DeAmnt2, DeSecDepAmnt, DeSSAmnt, DeOthAmnt, DeTaxAmnt, DeEduLoanAmnt, DeTfcFineAmnt } }) =>
      +(SalAmnt || 0) + +(IncAmnt2 || 0) + +(IncAmnt1 || 0) + +(IncAmnt3 || 0) + +(IncAmnt4 || 0) + +(OthAmnt || 0) 
          + +(LeftAmnt || 0) + +(IncAmnt5 || 0)
      - (+(DeAmnt1 || 0) + +(DeAmnt2 || 0) + +(DeSecDepAmnt || 0) + +(DeSSAmnt || 0) + +(DeOthAmnt || 0)
          + +(DeEduLoanAmnt || 0) + +(DeTaxAmnt || 0) + +(DeTfcFineAmnt || 0)),
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "Rmk",
    headerName: "หมายเหตุ",
    flex: 1,
    minWidth: 120,
  },
]

export const dirverSalaryMasterColumns = [
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "DrvCd",
    headerName: "รหัส พขร.",
    width: 80,
  },
  {
    field: "DrvNm",
    headerName: "พนักงานขับรถ",
    width: 220,
  },
  {
    field: "SalAmnt",
    headerName: salaryDriverColNm.SalAmnt,
    width: 110,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "IncAmnt2",
    headerName: salaryDriverColNm.IncAmnt2,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "IncAmnt1",
    headerName: salaryDriverColNm.IncAmnt1,
    width: 110,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "IncAmnt3",
    headerName: salaryDriverColNm.IncAmnt3,
    width: 125,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeSSPrct",
    headerName: salaryDriverColNm.DeSSPrct,
    width: 125,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? params.value : "-";
    },
  },
  {
    field: "DeAmnt1",
    headerName: salaryDriverColNm.DeAmnt1,
    width: 125,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeAmnt2",
    headerName: salaryDriverColNm.DeAmnt2,
    width: 125,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeSecDepAmnt",
    headerName: salaryDriverColNm.DeSecDepAmnt,
    width: 125,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? numberFormat(params.value) : "-";
    },
  },
  {
    field: "DeEduLoanAmnt",
    headerName: salaryDriverColNm.DeEduLoanAmnt,
    width: 125,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value ? params.value : "-";
    },
  },
]

export const salaryDriverDetailColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 60,
    align: 'center',
    renderCell: (params) => {
      return (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "JobOrdId",
    headerName: "เลขที่ใบงาน",
    width: 80,
  },
  {
    field: "LicNm",
    headerName: "ทะเบียนรถ",
    width: 80,
  },
  {
    field: "AptTm",
    headerName: "วันที่นัด",
    width: 100,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-";
    },
  },
  {
    field: "ContNo",
    headerName: "หมายเลขตู้",
    width: 120,
  },
  {
    field: "Loc",
    headerName: "สถานที่",
    width: 220,
  },
  {
    field: "E83",
    headerName: "ค่าเที่ยวคนขับ",
    width: 100,
    align: 'right',
    valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  },
  {
    field: "E86",
    headerName: "ค่าค้างคืน",
    width: 100,
    align: 'right',
    valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  },

  {
    field: "E3",
    headerName: "ค่ายกตุ้",
    width: 100,
    align: 'right',
    valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  },
  {
    field: "E5",
    headerName: "ค่าผ่านลาน",
    width: 100,
    align: 'right',
    valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  },
  {
    field: "E4",
    headerName: "ค่าผ่านท่า",
    width: 100,
    align: 'right',
    valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  },
  {
    field: "E84",
    headerName: "ทางด่วน",
    width: 100,
    align: 'right',
    valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  },
  {
    field: "E1000",
    headerName: "น้ำมันเงินสด",
    width: 100,
    align: 'right',
    valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  },
  {
    field: "OthAmnt",
    headerName: "ค่าอื่นๆ",
    width: 100,
    align: 'right',
    valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  },
  {
    field: "OthDscp",
    headerName: "รายละเอียดค่าอื่นๆ",
    minWidth: 150,
  },
  {
    field: "ExpTotal",
    headerName: "รวมค่าใช้จ่าย",
    width: 100,
    align: 'right',
    valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  },
  {
    field: "TotalOut",
    headerName: "โอนล่วงหน้า",
    width: 100,
    align: 'right',
    valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  },
  {
    field: "Total",
    headerName: "คงเหลือ",
    width: 100,
    align: 'right',
    valueGetter: ({ row }) => +(row.ExpTotal || 0) - row.TotalOut,
    valueFormatter: ({ value }) => value ? numberFormat(value) : '0.00',
    cellClassName: ({ value }) => value < 0 ? 'bg-red' : 'bg-green'
  },
]